import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "threat_name",
  "use": "threat_name-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"threat_name\"><path d=\"M4.388 11.963l-.714-.715L8.492 6.42l.725.725-4.83 4.818zM15.583 1.877L13.987.282a.958.958 0 00-1.358 0l-2.276 2.275L8.138.34 6.66 1.818l1.477 1.477-8.128 8.127-.01 4.449 4.45-.018 8.118-8.128 1.48 1.479 1.476-1.477-2.216-2.216 2.276-2.275a.961.961 0 000-1.36z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id